<div *ngIf="errorMessage" class="input-error">
    {{ errorMessage }}
</div>
